const isBrowser = typeof window !== 'undefined';
// const isBrowser = true;

export default isBrowser;
